import React from "react";
import { FaCheckCircle, FaExclamationTriangle, FaPhoneAlt, FaThumbsUp } from "react-icons/fa";
import "./OrderRisk.css";

/** Open orders with a medium or high refusal risk that nobody has checked yet. */
export const needsCall = (risk) => Boolean(risk && !risk.checked_at && (risk.level === "high" || risk.level === "medium"));

/** Small badge for the orders list. Hover shows the reasons. */
export function RiskBadge({ risk }) {
  if (!risk) return null;
  if (risk.checked_at && risk.level !== "low") {
    return (
      <span className="or-badge is-checked" title={`Verified by ${risk.checked_by || "staff"}`}>
        <FaCheckCircle size={10} /> Verified
      </span>
    );
  }
  if (risk.level === "low") return null;
  return (
    <span className={`or-badge is-${risk.level}`} title={risk.reasons.join("\n")}>
      <FaExclamationTriangle size={10} /> {risk.level === "high" ? "High risk" : "Check first"}
    </span>
  );
}

/**
 * Panel on the order page: why the order may be refused, the customer's good
 * history, a call button, and "I called, mark verified".
 */
export function RiskPanel({ risk, phone, busy, onMarkChecked }) {
  if (!risk) return null;
  const warn = risk.level !== "low";
  const tone = risk.checked_at ? "checked" : risk.level;

  if (!warn && !risk.good.length) {
    return (
      <div className="or-panel is-low">
        <div className="or-panel-head">
          <FaCheckCircle /> <strong>No warning signs</strong>
        </div>
        <p className="or-panel-sub">Phone, address and order history look normal.</p>
      </div>
    );
  }

  return (
    <div className={`or-panel is-${tone}`}>
      <div className="or-panel-head">
        {risk.checked_at ? <FaCheckCircle /> : warn ? <FaExclamationTriangle /> : <FaThumbsUp />}
        <strong>
          {risk.checked_at
            ? "Verified with the customer"
            : risk.level === "high"
              ? "High risk: call the customer before shipping"
              : risk.level === "medium"
                ? "Check this order before shipping"
                : "Trusted customer"}
        </strong>
      </div>
      {risk.checked_at && (
        <p className="or-panel-sub">
          {risk.checked_by || "Staff"} checked it on {new Date(risk.checked_at.replace(" ", "T")).toLocaleString()}.
        </p>
      )}
      {risk.reasons.length > 0 && (
        <ul className="or-reasons">
          {risk.reasons.map((reason) => <li key={reason}>{reason}</li>)}
        </ul>
      )}
      {risk.good.length > 0 && (
        <ul className="or-reasons is-good">
          {risk.good.map((note) => <li key={note}>{note}</li>)}
        </ul>
      )}
      {warn && (
        <div className="or-actions">
          {phone && (
            <a className="or-btn" href={`tel:${String(phone).replace(/[^\d+]/g, "")}`}>
              <FaPhoneAlt size={11} /> Call {phone}
            </a>
          )}
          <button type="button" className={`or-btn ${risk.checked_at ? "" : "is-primary"}`} disabled={busy} onClick={() => onMarkChecked(!risk.checked_at)}>
            {busy ? "Saving…" : risk.checked_at ? "Remove verification" : "I called, mark verified"}
          </button>
        </div>
      )}
    </div>
  );
}
